module.exports = __webpack_public_path__ + "img/afmf.ef2387c8.jpg";